
// データ管理

// vue
import Vue from 'vue';

export default new Vue({
    // データ
    data: {
        chara_list: {}
    },
    methods: {
        /**
         * プロパティ名を指定してデータを取得
         * @param {String} name
         * @return {Objecct}
         */
        get_data(name) {
            return this.$data[name];
        },
        /**
         * プロパティ名を指定して書き換え
         * @param {String} name
         * @param {*} val
         */
        set_data(name, val) {
            Vue.set(this, name, val);
        },
        /**
         * キャラ取得
         */
        get_chara(story, id) {
            const list = this.chara_list[story];
            let chara = null;
            for (let i = 0; i < list.length; i += 1) {
                if (list[i].id === id) {
                    chara = list[i];
                    break;
                }
            }
            return chara;
        }
    }
});



// WEBPACK FOOTER //
// ./js/page/chara/chara_data.js